export function toLocalDateTime({ value }) {
  return new Date(value).toLocaleString() || "Invalid Date";
}

export function toLocalDate({ value }) {
  return value === null ? "" : new Date(value).toLocaleDateString();
}

export function formatMeetingProvider({ value }) {
  switch (value) {
    case "ZOOM-MEETING":
      return "Zoom";
    case "TEAMS-MEETING":
      return "MS Teams";
    default:
      return "Unlisted";
  }
}

export function toUSD({ value }) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
}

export function formatFileSize({ value }) {
  if (!+value || value < 0) return "0 Bytes";
  let decimals = 2;
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(value) / Math.log(k));

  return `${parseFloat((value / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

// INTIMATION -> Intimation
export function caseStage({ value }) {
  return value ? value.charAt(0) + value.slice(1).toLowerCase() : "";
}

// An arbitrator is neutral, so they have no side.
export function caseUserSide({ value, data }) {
  if (data?.type === "ARBITRATOR") return "-";
  return value ? "PLAINTIFF" : "DEFENDANT";
}
export function caseUserPrimary({ value }) {
  return value === true ? "Yes" : "No";
}

export function formatQuestionOptions({ value }) {
  return value?.join(", ");
}

export function formatQuestionOptionType({ value }) {
  return value ? "Yes" : "No";
}

export function capitalizeFirst({ value = "" }) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
